import React from "react";
import { GiCardPick, GiSandsOfTime } from "react-icons/gi";
import { IoMdCloudDone } from "react-icons/io";
import { GoPlay, GoFileSubmodule } from "react-icons/go";
import { AiFillFileZip, AiFillHtml5, AiOutlineDropbox, AiOutlineDownload } from "react-icons/ai";
import { FaPlayCircle, FaBug, FaSearch, FaRobot, FaUpload, FaFileExcel, FaStopCircle, FaUserEdit, FaRegCalendarTimes, FaFilePdf } from "react-icons/fa";

//Funciones auxiliares:
const getMonthName = require('../../tools/formatters/dateFormatter').getMonthName;

//Estilos base:
let timelineIconBaseStyles = { marginTop: 11.5, fontSize: 21 };

export const getDataValidityPeriod = (process, defaultValue = "-") => {
    if (process.data_current_period) {

        if (process.data_current_period.length > 4) {
            const month = process.data_current_period.split(" ")[0];
            const year = process.data_current_period.split(" ")[1];
            
            return getMonthName(new Date(month + '/01/' + year), false) + " " + year;
        }
        else {
            return process.data_current_period;
        }

    }
    else {
        return defaultValue;
    }
}

export const getDownloadStatusColor = (downloadSource, includeVars = true) => {
    if (includeVars) {
        switch (downloadSource.status) {
            case "SUCCESS":
                return 'color: var(--success)';
            case "WARNING":
                return 'color: var(--success)';
            case "WAITING_FOR_USER_ACTION":
            case "PAUSED":
            case "QUEUE_PENDING":
            case "IN_PROCESS":
                return 'color: var(--warning)';
            case "CANCELLED":
            case "WAS_CANCELLED":
            case "ERROR":
                return 'color: var(--danger)';
            case "NEW":
                return 'color: var(--info)';
            default:
                return "";
        }
    }
    else {
        switch (downloadSource.status) {
            case "SUCCESS":
                return 'success';
            case "WARNING":
                return 'success';
            case "PAUSED":
            case "QUEUE_PENDING":
            case "IN_PROCESS":
                return 'warning';
            case "CANCELLED":
            case "WAS_CANCELLED":
            case "ERROR":
                return 'danger';
            case "WAITING_FOR_USER_ACTION":
            case "NEW":
                return 'info';
            default:
                return "";
        }
    }
}

export const getDownloadSourceTitle = (downloadSource) => {
    switch (downloadSource.status) {
        case "SUCCESS":
            return "Finalizado";
        case "WARNING":
            return "Finalizado *";
        case "QUEUE_PENDING":
            return "En cola";
        case "PAUSED":
        case "IN_PROCESS":
            return "En proceso";
        case "WAITING_FOR_USER_ACTION":
            return "En espera de usuario";
        case "CANCELLED":
        case "WAS_CANCELLED":
            return "Cancelado";
        case "ERROR":
            return "Error";
        case "NEW":
            return "Sin ejecutar";
        default:
            return "";
    }
}

export const getDownloadStatusDescription = (downloadSource, doBolding = false, allowColoring = false) => {
    let color = getDownloadStatusColor(downloadSource);

    switch (downloadSource.status) {
        case "SUCCESS":
            return "La descarga ha " + (doBolding ? "<b style='" + ((allowColoring) ? color : "") + "'>finalizado</b>" : "finalizado");
        case "WARNING":
            return "La descarga ha " + (doBolding ? "<b style='" + ((allowColoring) ? color : "") + "'>finalizado</b>" : "finalizado");
        case "PAUSED":
        case "QUEUE_PENDING":
            return "La descarga está " + (doBolding ? "<b style='" + ((allowColoring) ? color : "") + "'>en cola</b>" : "en cola");
        case "IN_PROCESS":
            return "La descarga está " + (doBolding ? "<b style='" + ((allowColoring) ? color : "") + "'>en progreso</b>" : "en progreso");
        case "WAITING_FOR_USER_ACTION":
            return "La descarga está " + (doBolding ? "<b style='" + ((allowColoring) ? color : "") + "'>en espera de usuario</b>" : "en espera de usuario");
        case "CANCELLED":
        case "WAS_CANCELLED":
            return "La descarga " + (doBolding ? "<b style='" + ((allowColoring) ? color : "") + "'>fue cancelada</b>" : "cancelado");
        case "ERROR":
            return "La descarga " + (doBolding ? "<b style='" + ((allowColoring) ? color : "") + "'>falló</b>" : "falló");
        case "NEW":
            return "La descarga aún " + (doBolding ? "<b style='" + ((allowColoring) ? color : "") + "'>no se ejecuta</b>" : "no se ejecuta");
        default:
            return "";
    }
}

export const getProcessTitle = (process) => {
    switch (process.status) {
        case "SUCCESS":
            return "Finalizado";
        case "WARNING":
            return "Finalizado *";
        case "QUEUE_PENDING":
            return "En cola";
        case "IN_PROCESS":
            return "En proceso";
        case "WAITING_FOR_USER_ACTION":
            return "En espera de usuario";
        case "CANCELLED":
        case "WAS_CANCELLED":
            return "Cancelado";
        case "ERROR":
            return "Error";
        case "NEW":
            return "Sin ejecutar";
        default:
            return "";
    }
}

export const getSourceTitleText = (downloadSourceDescription) => {
    let mainText = downloadSourceDescription.split(":");

    switch (mainText[0]) {
        case "Super Servicios":
            return "Superservicios";

        case "Super Financiera":
            return "Superfinanciera";

        default:
            return (mainText[0]);
    }
}

export const getSourceSubtitleText = (downloadSourceDescription, defaultText = "", includeDash = true) => {
    let mainText = downloadSourceDescription.split(":");

    if (mainText[1] !== undefined) { return (includeDash) ? (" - " + mainText[1]) : mainText[1]; }
    else { return (defaultText); }
}

export const getStatusButtonClassname = (process) => {
    switch (process.status) {
        case "SUCCESS":
        case "WARNING":
            return "btn btn-success";
        case "WAITING_FOR_USER_ACTION":
        case "PAUSED":
        case "QUEUE_PENDING":
        case "IN_PROCESS":
            return "btn btn-warning";
        case "CANCELLED":
        case "WAS_CANCELLED":
        case "ERROR":
            return "btn btn-danger";
        case "NEW":
            return "btn btn-info";
        default:
            return "";
    }
}

export const getStatusButtonLabel = (process) => {
    switch (process.status) {
        case "SUCCESS":
            return "Finalizado";
        case "WARNING":
            return "Finalizado *";
        case "PAUSED":
        case "IN_PROGRESS":
            return "En proceso";
        case "WAITING_FOR_USER_ACTION":
            return "En espera de usuario"
        case "CANCELLED":
        case "WAS_CANCELLED":
            return "Cancelado";
        case "ERROR":
            return "Error";
        case "NEW":
            return "Sin ejecutar";
        default:
            return "";
    }
}

export const getStatusIconClassname = (downloadSource) => {
    switch (downloadSource.status) {
        case "SUCCESS":
        case "WARNING":
            return "nc-icon nc-check-2 text-success";
        case "PAUSED":
        case "QUEUE_PENDING":
        case "IN_PROCESS":
            return "nc-icon nc-cloud-download-93 text-warning";
        case "WAITING_FOR_USER_ACTION":
            return "nc-icon nc-user-run text-warning";
        case "CANCELLED":
        case "WAS_CANCELLED":
        case "ERROR":
            return "nc-icon nc-simple-remove text-danger";
        case "NEW":
            return "nc-icon nc-send text-info";
        default:
            return "";
    }
}

export const getStatusIconTitle = (process) => {
    switch (process.status) {
        case "SUCCESS":
            return "Finalizado";
        case "WARNING":
            return "Finalizado *";
        case "QUEUE_PENDING":
            return "En cola";
        case "PAUSED":
        case "IN_PROCESS":
            return "Descargando";
        case "WAITING_FOR_USER_ACTION":
            return "Esperando usuario"
        case "CANCELLED":
        case "WAS_CANCELLED":
            return "Cancelado";
        case "ERROR":
            return "Error";
        case "NEW":
            return "Sin ejecuciones";
        default:
            return "";
    }
}

export const getTimelineDivClassname = (timelineItem) => {
    switch (timelineItem.status) {
        case "SUCCESS":
        case "WARNING":
            return "success";
        case "WAITING_FOR_USER_ACTION":
        case "PAUSED":
        case "QUEUE_PENDING":
        case "IN_PROCESS":
            return "warning";
        case "CANCELLED":
        case "ERROR":
            return "danger";
        default:
            return "info";

    }
}

export const getTimelineIconClassname = (timelineItem) => {
    switch (timelineItem.name.toUpperCase()) {
        case "START":
            return <GoPlay style={{ ...timelineIconBaseStyles }} />;
        case "GETTING_INITIAL_DATA":
            return <GoFileSubmodule style={{ ...timelineIconBaseStyles }} />;
        case "EXTRACTING_DATA":
        case "EXTRACT_DATA":
            return <GiCardPick style={{ ...timelineIconBaseStyles }} />;
        case "WAITING_FOR_WORKER":
            return <GiSandsOfTime style={{ ...timelineIconBaseStyles }} />;
        case "SCRAPPING":
        case "SCRATCHING":
            return <FaBug style={{ ...timelineIconBaseStyles }} />;
        case "SURFING":
            return <FaSearch style={{ ...timelineIconBaseStyles }} />;
        case "DOWNLOADING":
            return <FaPlayCircle style={{ ...timelineIconBaseStyles }} />;
        case "TRANSFORMING":
        case "TRANSFORMING_&_GENERATING_FILE":
        case "TRANSFORMING_XBRL":
            return <FaRobot style={{ ...timelineIconBaseStyles }} />;
        case "TRANSFORMING_XSL":
        case "TRANSFORMING_XLS":
        case "TRANSFORMANDO XLS":
            return <FaFileExcel style={{ ...timelineIconBaseStyles }} />;
        case "TRANSFORMANDO PDF":
        case "TRANSFORMING_PDF":
            return <FaFilePdf style={{ ...timelineIconBaseStyles }} />;
        case "READING_TRANSFORMING_HTML":
            return <AiFillHtml5 style={{ ...timelineIconBaseStyles }} />;
        case "DOWNLOADING_FROM_S3":
            return <AiOutlineDownload style={{ ...timelineIconBaseStyles }} />;
        case "CREATING_OUTPUT":
            return <AiOutlineDropbox style={{ ...timelineIconBaseStyles }} />;
        case "COMPRESSING_FOLDER":
        case "DECOMPRESS":
            return <AiFillFileZip style={{ ...timelineIconBaseStyles }} />;
        case "SENDING_FILE_VIA_SFTP":
            return <FaUpload style={{ ...timelineIconBaseStyles }} />;
        case "CANCELLED":
        case "WAS_CANCELLED":
            return <FaStopCircle style={{ ...timelineIconBaseStyles }} />;
        case "GENERIC_PROCESS":
            return <FaRobot style={{ ...timelineIconBaseStyles }} />;
        case "WAITING_CAPTCHA":
            return <FaUserEdit style={{ ...timelineIconBaseStyles }} />;
        case "PAUSED_BY_SCHEDULE":
            return <FaRegCalendarTimes  style={{ ...timelineIconBaseStyles }} />;
        case "FINISH":
        case "END":
            return <IoMdCloudDone style={{ ...timelineIconBaseStyles }} />;
        default:
            return timelineItem.name;
    }
}

export const getScratchUrl = (downloadSource) => {
    try { return downloadSource.url || "https://fitideas.co/" }
    catch (error) { return "" };
}